import { render, staticRenderFns } from "./outpatient.vue?vue&type=template&id=61eb52b6&scoped=true&"
import script from "./outpatient.vue?vue&type=script&lang=js&"
export * from "./outpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb52b6",
  null
  
)

export default component.exports